export var TestContentTypeName;

(function (TestContentTypeName) {
  TestContentTypeName["Article"] = "TEST_ARTICLE";
  TestContentTypeName["Person"] = "TEST_PERSON";
  TestContentTypeName["WithNoBuildPage"] = "TEST_WITH_NO_BUILD_PAGE";
})(TestContentTypeName || (TestContentTypeName = {}));